import { render, staticRenderFns } from "./LaudoMutPastagemModal.vue?vue&type=template&id=796a7e1a&scoped=true&lang=pug"
import script from "./LaudoMutPastagemModal.vue?vue&type=script&lang=js"
export * from "./LaudoMutPastagemModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoMutPastagemModal.vue?vue&type=style&index=0&id=796a7e1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a7e1a",
  null
  
)

export default component.exports